<template>
  <div>
    <div style="overflow-x: scroll;">
      <table class="table table-hover table-bordered" style="width:auto">
        <thead>
        <th>&nbsp;</th>

        <th
            v-for="fill in fills"
            :key="'fill-' + fill.id"
            class="px-1 text-center">
          <small class="font-weight-bold">{{fill.title}}</small>
        </th>
        </thead>
        <tbody
            v-for="catalog in data"
            :key="catalog.id">
        <th :colspan="fills.length + 1">
          {{catalog.name}}
        </th>
        <tr
            v-for="item in catalog.items"
            :key="item.id">
          <td width="400" style="width: 400px !important;" class="text-nowrap">
            {{ item.title }}
          </td>

          <td
              v-for="fill in fills"
              :key="'fill-' + fill.id"
              class="px-0">
            <div
                v-for="field in item.fields"
                :key="field.id"
                :class="'text-center text-nowrap checkup-strength-' + field.strength"
                style="width:100px;overflow:hidden;">
              <div v-if="fill.answers[field.id]">
                <small v-if="field.type === 'check'" :title="field.label">
                  {{field.label}}
                </small>

                <small v-else :title="fill.answers[field.id]">
                  {{fill.answers[field.id]}}
                </small>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import formatDate from '../../../utils/formatDate';

  export default {
    name: 'CheckupCalendar',

    props: ['prescriptions', 'catalogs', 'answers'],

    data() {
      return {};
    },

    computed: {
      fills() {
        const fills = this.answers.map(fill => {
          const { id, createdAt } = fill;
          const date = new Date(createdAt);
          const sort = formatDate(date, 'ymd');
          const title = formatDate(date, 'd.m');
          const answers = {};

          fill.answers.forEach(({ field, value }) => {
            answers[field] = value;
          });

          return { id, sort, title, answers };
        });

        fills.sort((a, b) => a.sort - b.sort);

        return fills;
      },

      data() {
        const catalogs = {};

        this.prescriptions.forEach(prescription => {
          if (!catalogs[prescription.item.catalog]) {
            catalogs[prescription.item.catalog] = {
              id: prescription.item.catalog,
              name: '-',
              sort: 1000,
              items: [],
            };
          }

          const item = {
            id: prescription.item.id,
            title: prescription.item.title,
            fields: prescription.item.fields,
            sort: prescription.item.sort,
          };

          catalogs[prescription.item.catalog].items.push(item);

          catalogs[prescription.item.catalog].items.sort((a, b) => a.sort - b.sort);
        });

        this.catalogs.forEach(catalog => {
          if (catalogs[catalog.id]) {
            catalogs[catalog.id].name = catalog.name;
            catalogs[catalog.id].sort = catalog.sort;
          }
        });

        const sortedCatalogs = Object.values(catalogs);

        sortedCatalogs.sort((a, b) => a.sort - b.sort);

        return sortedCatalogs;
      },
    },

    methods: {},
  };
</script>
